import { createUseStyles } from 'react-jss';

export default createUseStyles({
  form: {
    marginTop: '40px',
  },
  button: {
    width: '25%',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },
});
